import { gql } from 'urql';
import { FileFragment } from './fileFragment';

export const MessageFragment = gql`
  ${FileFragment}
  fragment MessageFragment on Message {
    id
    conversationID
    createdAt
    updatedAt
    changeToken
    sender
    __typename
    hasOnboardingReminder
    ... on FreeformMessage {
      message
      hasOnboardingReminder
      suggestedResponses
      attachments {
        ...FileFragment
      }
    }
  }
`;
